jQuery(function($){
    if ($('.home-hero').length) {
        if (hero_data) {
            var index = Math.floor(Math.random() * hero_data.length);
            var position = hero_data[index].background_focus_point;
            if (!position) {
                position = 'center';
            }
            $('.home-hero').css({'background-image':'url(' + hero_data[index].background_image + ')', 'background-position': position + ' top 9vh'});
        }
    }
});
